// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.paymenttypes', {
        url: '/paymenttypes?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/paymenttypes/paymenttypes.tpl.html',
            controller: 'PaymentTypesController as vm'
        }},
        resolve: {
            paymentTypes: paymentTypesResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function paymentTypesResolver(PaymentTypesApiService, $stateParams) {
    return PaymentTypesApiService.getPaymentTypes({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function PaymentTypesController($rootScope, $state, $scope, paymentTypes, PaymentTypesApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.paymentTypes = paymentTypes;
    vm.selectedPaymentTypeId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.paymentTypeId; }, function(newValue, oldValue) {
            vm.selectedPaymentTypeId = parseInt($state.params.paymentTypeId,10);
        });
        $rootScope.$on('PaymentType.Inserted', function(event, response) {
        });
        $rootScope.$on('PaymentType.Updated', function(event, response) {
        });
        $rootScope.$on('PaymentType.Deleted', function(event, response) {
        });
        $rootScope.$on('PaymentType.Changed', function(event, response) {
            loadPaymentTypes();
        });
    }

    function loadPaymentTypes() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        PaymentTypesApiService.getPaymentTypes(request).then(function(response) {
            vm.paymentTypes = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadPaymentTypes();
    }

}

angular
    .module('base.paymenttypes', ['paymenttypes.api','paymenttypes.paymenttype'])
    .config(stateConfig)
    .controller('PaymentTypesController', PaymentTypesController);
